import React from 'react';
import styled from 'styled-components';
import Separator from '../ui/Separator';
import { Link } from 'gatsby';
import { getSlug } from '../../utils/getSlug';

const RelatedTripsLocationsStyling = styled.div`
	width: 100%;
	margin-top: 24px;
	display: flex;
	flex-direction: column;
	gap: 16px;

	.related-item {
		display: flex;
		justify-content: space-between;
	}
	.item {
		color: var(--orange-120);
		text-decoration: underline;
	}
	.items {
		display: flex;
		gap: 8px;
		.item {
			color: var(--red);
		}
	}
`;

const RelatedTripsLocations = ({ relatedTrip, relatedLocations }) => {
	return (
		<RelatedTripsLocationsStyling className="related">
			{relatedTrip && <Separator color='grey-thin' />}

			{relatedTrip && (
				<div className='related-item'>
					<p>Related Trip</p>
					<Link to={getSlug(relatedTrip)} className='item'>
						<p>{relatedTrip.title}</p>
					</Link>
				</div>
			)}
			{relatedLocations && relatedLocations.length > 0 && (
				<div className='related-item'>
					<p>Related Locations</p>
					<div className='items'>
						{relatedLocations.map((location, index) => (
							<Link key={index} to={getSlug(location)} className='item'>
								<p>{location.name}</p>
							</Link>
						))}
					</div>
				</div>
			)}
		</RelatedTripsLocationsStyling>
	);
};

export default RelatedTripsLocations;
